import React from "react"
import { Link } from "gatsby"
import { Row, Col } from "react-bootstrap"
import FooterLogo from "./footer-logo"
import FooterStyle from "./footer.module.scss"

const Footer = () => (
    <div className={FooterStyle.footerDiv}>
        <Row className={FooterStyle.footerRow1}>
           <Col className={FooterStyle.footerLinkCol1} md={6} lg={3}>
                <h3 className={FooterStyle.footerTitle}>Explore</h3>
                <Link id="home" className={FooterStyle.footerLinks} to="/">Home</Link>
                <Link className={FooterStyle.footerLinks} to="/pricing">Pricing</Link>
                <Link className={FooterStyle.footerLinks} to="/templates">Templates</Link>
                <Link className={FooterStyle.footerLinks} to="/our-story">Our Story</Link>
                <Link className={FooterStyle.footerLinks} to="/covid19-response">COVID-19 Response</Link>
            </Col>
            <Col className={FooterStyle.footerLinkCol2} md={6} lg={3}>
                <h3 className={FooterStyle.footerTitle}>Website Features</h3>
                <Link className={FooterStyle.footerLinks} to="/essentials">The Essentials</Link>
                <Link className={FooterStyle.footerLinks} to="/mobile-first">Mobile First</Link>
                <Link className={FooterStyle.footerLinks} to="/engaging-menu">Engaging Menu</Link>
                <Link className={FooterStyle.footerLinks} to="/convenient-booking">Convenient Booking</Link>
            </Col> 
            <Col className={FooterStyle.footerLinkCol3} md={6} lg={3}>
                <h3 className={FooterStyle.footerTitle}>Social Media</h3>
                <a className={FooterStyle.footerLinks} href="https://www.linkedin.com/company/first-string-digital/" target="_blank"  rel="noopener noreferrer">LinkedIn</a>
                <a className={FooterStyle.footerLinks} href="https://www.twitter.com/weareFSDigital" target="_blank"  rel="noopener noreferrer">Twitter</a>
                <a className={FooterStyle.footerLinks} href="https://www.youtube.com/channel/UCIuR10cXn6xTdCQhDgN-cIA" target="_blank"  rel="noopener noreferrer">YouTube</a>
            </Col> 
            <Col className={FooterStyle.footerLinkCol4} md={6} lg={3}>
            <h3 className={FooterStyle.footerTitle}>Contact Us</h3>
                <a className={FooterStyle.footerLinks} href="mailto:info@firststringdigital.com">info@firststringdigital.com</a>
                <a className={FooterStyle.footerLinks} href="tel:+012068553110">US: +1 206-855-8110</a>
                <a className={FooterStyle.footerLinks} href="tel:+526242244028">Mex: +52 624-224-4028</a>
            </Col> 
        </Row>
        <hr className={FooterStyle.footerHr} />
        <Row className={FooterStyle.footerRow1}>
            <Col className={FooterStyle.footerCol1} md={6} lg={2} xl={3}>
                <FooterLogo />
            </Col>
            <Col className={FooterStyle.footerCol2} md={12} lg={6} xl={6}>
            <p className={FooterStyle.footerCopyright}>Created by First String Digital, &copy; {(new Date().getFullYear())}, All Rights Reserved</p>
            </Col>
            <Col className={FooterStyle.footerCol3} md={6} lg={4} xl={3}>
                <Link className={FooterStyle.footerRow2Links} to="/terms-of-service">Terms of Service</Link>
                <span className={FooterStyle.footerVerticalLine}>|</span>
                <Link className={FooterStyle.footerRow2Links} to="/privacy-policy">Privacy Policy</Link>
            </Col>
        </Row>
    </div>
)

export default Footer